/* VSKLO floating callback lightweight loader.
   Keeps only the visible launcher in the initial DOM and loads the full callback runtime on launcher intent. */
(function () {
  'use strict';

  if (window.__VSKLO_FLOATING_CONTACT_LOADER_V1__) return;
  window.__VSKLO_FLOATING_CONTACT_LOADER_V1__ = true;

  var PLACEHOLDER_ID = 'vsklo-floating-contact-placeholder';
  var corePromise = null;
  var currentScript = document.currentScript;

  function coreUrl() {
    // The Shopify core asset has its own cache fingerprint; preserve it.
    var declared = currentScript && currentScript.getAttribute('data-vsklo-core-src');
    if (declared) {
      try {
        var canonical = new URL(declared, window.location.href);
        if (canonical.protocol === 'https:' || canonical.protocol === 'http:') return canonical.toString();
      } catch (error) {}
    }
    if (!currentScript || !currentScript.src) return '';
    try {
      var url = new URL(currentScript.src, window.location.href);
      url.pathname = url.pathname.replace(/vsklo-floating-contact-v11\.js$/, 'vsklo-floating-contact-v11-core.js');
      url.search = '';
      return url.toString();
    } catch (error) {
      return currentScript.src.replace(/vsklo-floating-contact-v11\.js(?:\?[^#]*)?/, 'vsklo-floating-contact-v11-core.js');
    }
  }

  function localeText() {
    var lang = (document.documentElement.lang || (window.Shopify && Shopify.locale) || 'uk').toLowerCase();
    if (lang.indexOf('de') === 0) return 'Rückruf anfordern';
    if (lang.indexOf('pl') === 0) return 'Zamów rozmowę';
    if (lang.indexOf('en') === 0) return 'Request a call';
    return 'Замовити дзвінок';
  }

  function activateRealButton() {
    var real = document.querySelector('#vsklo-floating-contact [data-vsklo-floating-open]');
    if (real && typeof real.click === 'function') real.click();
  }

  function loadCore(openAfterLoad) {
    if (window.__VSKLO_FLOATING_CONTACT_V11__) {
      var existingPlaceholder = document.getElementById(PLACEHOLDER_ID);
      if (existingPlaceholder) existingPlaceholder.remove();
      if (openAfterLoad) activateRealButton();
      return Promise.resolve();
    }

    if (!corePromise) {
      var src = coreUrl();
      if (!src) {
        return Promise.reject(new Error('Floating contact core URL is unavailable'));
      }
      if (!window.VSKLOAssetLoader || typeof window.VSKLOAssetLoader.loadScript !== 'function') {
        return Promise.reject(new Error('Shared asset loader is unavailable'));
      }

      corePromise = window.VSKLOAssetLoader.loadScript({
        key: 'floating-contact-core',
        src: src,
        parent: 'head',
        ready: function () {
          return window.__VSKLO_FLOATING_CONTACT_V11__ ? true : null;
        },
        label: 'Floating contact core'
      })
        .then(function () {
          var placeholder = document.getElementById(PLACEHOLDER_ID);
          if (placeholder) placeholder.remove();
        })
        .catch(function (error) {
          corePromise = null;
          throw error;
        });
    }

    if (openAfterLoad) corePromise.then(activateRealButton).catch(function () {});
    return corePromise;
  }

  function ensurePlaceholder() {
    if (!document.body || document.getElementById(PLACEHOLDER_ID) || document.getElementById('vsklo-floating-contact')) return;

    var button = document.createElement('button');
    button.id = PLACEHOLDER_ID;
    button.type = 'button';
    button.setAttribute('aria-label', localeText());
    button.className = 'vsklo-utility-contact-launcher';
    // Geometry and icon dimensions are owned by assets/vsklo-core-ui.css.
    button.innerHTML = '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M6.6 10.8c1.6 3.1 3.5 5 6.6 6.6l2.2-2.2c.3-.3.8-.4 1.2-.3 1.3.4 2.6.6 4 .6.7 0 1.2.5 1.2 1.2v3.5c0 .7-.5 1.2-1.2 1.2C10.2 22 2 13.8 2 3.4 2 2.7 2.5 2.2 3.2 2.2h3.5c.7 0 1.2.5 1.2 1.2 0 1.4.2 2.7.6 4 .1.4 0 .9-.3 1.2l-1.6 2.2Z" stroke="currentColor" stroke-width="1.85" stroke-linecap="round" stroke-linejoin="round"/></svg>';

    var warmCore = function () {
      loadCore(false).catch(function () {});
    };

    button.addEventListener('pointerenter', warmCore, { once: true, passive: true });
    button.addEventListener('focus', warmCore, { once: true });
    button.addEventListener('touchstart', warmCore, { once: true, passive: true });
    var opening = false;
    button.addEventListener('click', function () {
      if (opening) return;
      opening = true;
      loadCore(true).catch(function () {
        // Failed script loads leave the launcher visible; permit retry.
      }).finally(function () {
        opening = false;
      });
    });

    document.body.appendChild(button);
  }

  function bindExternalTriggers() {
    document.addEventListener('click', function (event) {
      var trigger = event.target && event.target.closest
        ? event.target.closest('[data-vsklo-contact-trigger], [data-vsklo-floating-open], a[href="#vsklo-floating-contact"]')
        : null;
      if (!trigger || trigger.closest('#vsklo-floating-contact')) return;
      event.preventDefault();
      loadCore(true).catch(function () {});
    });
  }

  function init() {
    ensurePlaceholder();
    bindExternalTriggers();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
